var _title, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCareers24Dp = function SvgCareers24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ICON/Careers_24dp")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807",
    transform: "translate(-1594.000000, -812.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ICON/Careers_24dp",
    transform: "translate(1594.000000, 812.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,21 L5,21 C3.9,21 3,20.1 3,19 L3,19 L3,16 L5,16 L5,19 L8,19 L8,21 Z M19,19 L19,16 L21,16 L21,19 C21,20.1 20.1,21 19,21 L19,21 L16,21 L16,19 L19,19 Z M19,5 L16,5 L16,3 L19,3 C20.1,3 21,3.9 21,5 L21,5 L21,8 L19,8 L19,5 Z M5,5 L5,8 L3,8 L3,5 C3,3.9 3.9,3 5,3 L5,3 L8,3 L8,5 L5,5 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,9 C15,10.66 13.66,12 12,12 C10.34,12 9,10.66 9,9 C9,7.34 10.34,6 12,6 C13.66,6 15,7.34 15,9 Z M6,17 C6,15 10,13.9 12,13.9 C14,13.9 18,15 18,17 L18,18 L6,18 L6,17 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))))));
};

export { SvgCareers24Dp as ReactComponent };
export default __webpack_public_path__ + "38d6a7fa43d69fc5dbe099d30d633954.svg";